import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import RequestService from "../../services/RequestService";
import MinorRequestDetails from "../molecules/MinorRequestDetails";
import { parseISO, format } from "date-fns";
import StatusRequests from '../../enums/StatusRequests'
import { MdSend } from "react-icons/md";
import { FaStamp } from 'react-icons/fa';
import TiposGestao, { getDescricaoByCod } from "../../enums/TiposGestao";

export default function SendToBackOfficeModal({
  isModalOpen,
  setModalOpen,
  requestId,
  requestNro,
  isGestao,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [requestObject, setRequestObject] = useState();
  const [resetSla, setResetSla] = useState(false);

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);
      // console.log(request?.request.idRequest);
    }

    fetchRequest();
  }, [isModalOpen, requestId]);

  const handleResetSla = (event) => {
    setResetSla(event.target.checked);
  };

  const onSubmit = async (data) => {
    // const now = new Date().toLocaleString(undefined, {
    //   year: '2-digit',
    //   month: '2-digit',
    //   day: '2-digit',
    //   hour: '2-digit',
    //   minute: '2-digit',
    // });

    // console.log(data);

    // Adicionar o prefixo "GESTÃO: " ao valor do campo observacao
    // if (!requestObject.request.observacao)
    // data.observacao = `${now} - ${requestObject?.request?.status}: ${data.observacao}`;
    // else
    // data.observacao = `${requestObject?.request?.observacao}\n------\n${now} - ${requestObject?.request?.status}: ${data.observacao}`;

    data = { ...data, status: "BACKOFFICE" ,  codItemsAtendidos: [], quantidadeRestaAtender: requestObject?.request?.quantidadeAtender};    

    const response = await RequestService.updateParcial(requestId, data);

    if (response) {
      toast.success("Enviado para Backoffice!");
    } else {
      // console.log(error)
      toast.error("Ops! Algo deu errado");
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    setResetSla(false)
    reset();
  };

  // Obtém a data e hora atual no formato YYYY-MM-DDTHH:MM
  const today = new Date();
  today.setDate(today.getDate() + 1);
  const minDateTime = today.toISOString().slice(0, 16);

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div 
          className="fixed inset-0 z-10 w-screen overflow-y-auto py-8"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-fit max-w-[700px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">
                <div className="flex gap-2 items-center text-white text-xl font-bold">
                  <MdSend />
                  VOLTAR PARA BACKOFFICE
                </div>
                <div className="ms-4 flex justify-between">
                  <div className="text-sm">
                    Solicitação nº: {requestObject?.request?.idRequest}
                  </div>
                  <div className="text-sm">
                    {/* Criado em: {requestObject?.request?.createdAt } */}
                    Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
                  </div>
                  <div className="flex items-center gap-2">
                    Status:
                    <p  className="text-sm text-black rounded-lg px-2"
                        style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div>
              </div>

              <MinorRequestDetails request={requestObject?.request} divBoleto={true}/>
              {isGestao &&

                <div className="flex flex-col py-2 px-4 mt-1 mx-2 gap-2 bg-red-100 border rounded-md text-xs">
                  <div className="flex flex-row gap-2 w-full">
                    <div className="flex items-start gap-1 w-full">
                      <label className="block text-gray-700 font-bold whitespace-nowrap">Motivo Gestão:</label>
                      <div className="whitespace-nowrap">{requestObject?.request?.motivoEnvioGestao} - {getDescricaoByCod(requestObject?.request?.motivoEnvioGestao)}</div>
                    </div>
                    <div className="flex flex-col items-start gap-1 w-full">
                      <div className="flex w-full justify-end gap-2">
                        <label className="text-gray-700 font-bold whitespace-nowrap">
                          Reiniciar SLA?
                        </label>

                        <input
                        {...register("resetSla")}
                          id="resetSla"
                          type="checkbox"
                          checked={resetSla}
                          onChange={handleResetSla}
                          className="form-checkbox h-4 w-4 text-blue-600"
                        />

                      </div>

                      
                    </div>
                  </div>

                  <div className="flex gap-2">
                  {resetSla && 
                  <div className="flex flex-col items-start gap-1 w-full">
                    <label className="text-gray-700 font-bold whitespace-nowrap">
                          Motivo Reiniciar SLA:
                    </label>
                    <input
                      disabled={!resetSla}
                      type="text"
                      {...register("motivoResetSla", { required: resetSla ? true : false, })}
                      className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 disabled:bg-gray-200
                          ${errors?.motivoResetSla?.type === "required" && resetSla
                          ? " border border-red-500 outline-none ring-0"
                          : "border border-zinc-500 outline-none ring-0"
                        }
                          `}
                    />
                    {errors?.motivoResetSla?.type === "required" && resetSla && (
                      <p className="text-red-500 text-xs ms-2">
                        Campo obrigatório
                      </p>
                    )}

                  </div>
                  }

                  {resetSla && ( requestObject?.request?.tipoAtendimento === 'programado' || requestObject?.request?.tipoAtendimento === 'bbn-alta' || requestObject?.request?.tipoAtendimento === 'bbn-media' ) &&
                    <div className="flex flex-col items-start gap-1 w-2/3">
                      <label className="block text-gray-700 font-bold whitespace-nowrap">
                        Programar para:
                      </label>
                      <input
                        {...register("novaDataHoraProgramado", { required: (requestObject?.request?.tipoAtendimento === 'programado' || requestObject?.request?.tipoAtendimento === 'bbn-alta' || requestObject?.request?.tipoAtendimento === 'bbn-media') ? true : false })}
                        // disabled={!isProgramado ? true : false}
                        min={minDateTime}
                        type="datetime-local"
                        placeholder="Start Date and Time"
                        className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                            ${errors?.novaDataHoraProgramado?.type === "required"
                            ? " border border-red-500 outline-none ring-0"
                            : "border border-zinc-500 outline-none ring-0"
                          }
                            `}
                      />
                      
                      <p className="text-red-500 text-xs ms-2">
                        *Agendar entre 9h e 17h
                      </p>
                      
                      {errors?.novaDataHoraProgramado?.type === "required" && (
                        <p className="text-red-500 text-xs ms-2">
                          Campo obrigatório
                        </p>
                      )}
                    </div>
                  }
                  </div>

                  
                  
                </div>
}

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-4 px-4 text-xs">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col gap-2 px-4">

                    

                  <div className="flex flex-row gap-2 w-full">

                  
                    
                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Observação:</label>
                      <textarea
                        {...register("obsAtualizacao", { required: true })}
                        className={`
                              w-full h-[70px] p-4 bg-white rounded-2xl justify-start items-center inline-flex resize-none 
                              text-neutral-600 font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-neutral-400 placeholder:font-normal
                              ${
                                errors?.obsAtualizacao?.type === "required" ?
                                "border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                        placeholder={"Observação"}>
                      </textarea>
                      {errors?.obsAtualizacao?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div>
                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <div className="flex gap-1 text-gray-700">
                        <FaStamp />
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Carimbo:</label>
                      </div>
                      <textarea
                        {...register("carimbo", { 
                          // required: true 
                        })}
                        className={`
                              w-full h-[70px] p-4 bg-white rounded-2xl justify-start items-center inline-flex resize-none 
                              text-neutral-600 font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-neutral-400 placeholder:font-normal
                              ${
                                errors?.carimbo?.type === "required" ?
                                "border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                        placeholder={"Observação"}>
                      </textarea>
                      {errors?.carimbo?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div>

                  </div>

                    <button
                      onClick={() => handleSubmit(onSubmit)()}
                      className="w-full bg-blue-500 text-white py-2 px-4 rounded-2xl hover:bg-blue-600"
                    >
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
